import React, { PropsWithChildren, useContext } from 'react';

import PartnerProfileContext from './PartnerProfileContext';
import useMutationPartnerProfile from './useMutationPartnerProfile';
import useQueryPartnerProfile from './useQueryPartnerProfile';

function Provider({
  children,
  optionsQuery,
  optionsMutation,
}: PropsWithChildren<{
  optionsQuery?: Parameters<typeof useQueryPartnerProfile>[0];
  optionsMutation?: Parameters<typeof useMutationPartnerProfile>[0];
}>) {
  const query = useQueryPartnerProfile(optionsQuery);
  const mutation = useMutationPartnerProfile(optionsMutation);

  return (
    <PartnerProfileContext.Provider
      value={{
        isLoading: query.isLoading || mutation.isLoading,
        partnerProfile: query.data,
        updatePartnerProfile: mutation.mutateAsync,
      }}
    >
      {children}
    </PartnerProfileContext.Provider>
  );
}

function usePartnerProfile() {
  return useContext(PartnerProfileContext);
}

export default Provider;
export { usePartnerProfile };
